module.exports = __webpack_public_path__ + "img/fake.26993795.png";